<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_LIST')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách Merchant</h1>
      <div class="btn-group float-right">
        <DraggableTable :naming="$route.name" v-model="fieldTable" @change="filterTable = $event" />
        <button
          type="button"
          class="f12 font-medium btn btn-outline-secondary"
          v-show="
            this.selected.length > 0 &&
            dataPermission &&
            dataPermission.includes('CNPS_CSTM_MERCHANT_UPDATE')
          "
          @click="openPopupDeploymentStaff()"
        >
          Gán nhân viên chăm sóc MC
        </button>
        <button
          @click="exportExcel"
          class="f12 font-medium btn btn-outline-secondary"
          v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_EXPORT')"
        >
          <i class="bx bx-download"></i> Xuất file
        </button>
      </div>
    </div>
    <!-- <div class="btn-group float-right sm-float-none">
        <button
          class="f12 font-medium btn btn-outline-secondary"
          v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_PRE_TRANSFER')"
          @click="transMC()"
        >
          <i class="bx bx-plus-circle"></i> Điều chuyển
        </button>

        <input ref="file" type="file" hidden />

        <button
          class="f12 font-medium btn btn-outline-secondary"
          @click="openFile()"
          v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_UPLOAD')"
        >
          <i class="bx bx-upload"></i> Nhập file
        </button>

        <button
          class="f12 font-medium btn btn-outline-secondary"
          v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_ADD')"
          @click="$router.push('/merchant-add')"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
      </div> -->
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.textSearch"
              class="form-control f12 hc-37 text-search"
              placeholder="Tên MC/Email/SĐT"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionId"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              placeholder="Vùng kinh doanh"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.cityCode"
              :options="dataProvince"
              placeholder="Tỉnh/Thành phố"
            />
          </div>

          <div class="form-group">
            <Select2 v-model="search.superior" :options="dataManager" placeholder="Quản lý" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.mposCreatedSaleId"
              :options="listUser"
              placeholder="NV phát triển HĐ MPOS"
            />
          </div>

          <div class="form-group">
            <Select2 v-model="search.saleId" :options="listUser" placeholder="Nhân viên chăm sóc" />
          </div>

          <div class="form-group">
            <Select2 v-model="search.referSource" :options="sourceCreate" placeholder="Nguồn tạo" />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.isOnUs"
              :options="[
                { id: 0, text: 'Tất cả' },
                { id: true, text: 'Có' },
                { id: false, text: 'Không' },
              ]"
              placeholder="Tình trạng ONUS"
            />
          </div>

          <!-- <div class="form-group">
            <Select2
              :options="listCTV"
              v-model="search.agentId"
              placeholder="Cộng tác viên"
            />
          </div> -->

          <div class="form-group">
            <Select2 v-model="search.mcc" :options="dataConfigMcc" placeholder="Ngành nghề" />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.searchServiceType"
              :options="dataConfigService"
              placeholder="Dịch vụ ký HĐ"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.salesProcess"
              :options="listStateSearch"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.mcLvl"
              :options="Config.getSearch(Config.mcKeyLvl)"
              placeholder="Cấp bậc MC"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.isReassign"
              :options="reassignOption"
              placeholder="Gán lại NVCS?"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.enableReceived"
              :options="enableReceivedOption"
              placeholder="MC muốn nhận tiền trực tiếp về TK"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.statusKyc"
              :options="statusKycFilterOptions"
              placeholder="Trạng thái EKYC"
            />
          </div>

          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div
              v-if="hasDefaultFilter"
              class="mb-2 d-inline-flex align-items-center"
              style="
                background-color: #fff3e0;
                padding: 6px 12px;
                border-radius: 4px;
                font-size: 13px;
              "
            >
              <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
              <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
              <button
                @click="removeTimeFilter"
                type="button"
                class="ml-2 btn-close-filter"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 0 4px;
                  color: #e65100;
                  font-size: 16px;
                  line-height: 1;
                "
                title="Bỏ lọc"
              >
                ×
              </button>
            </div>
            Tổng merchant:
            <strong class="text-primary">{{ pagination?.total?.toLocaleString('vi-VN') }}</strong>
            <b-table
              hover
              sticky-header
              responsive
              :items="dataMerchant"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
              :busy.sync="loading"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #head(selected)>
                <b-form-checkbox v-model="selectAllAction"></b-form-checkbox>
              </template>
              <template #cell(selected)="data">
                <b-form-checkbox
                  v-model="selected"
                  :value="data.item.customerId ? data.item.customerId : ''"
                  @change="checkSelectedItem(data.item.customerId)"
                ></b-form-checkbox>
              </template>
              <template #cell(merchant)="data">
                {{ data.item.customerName }}<br />
                {{ data.item.merchantName }}<br />
                {{ data.item.mobile | encryptPhone }}
                <br />
                <a
                  v-if="!(data.item && data.item.accIdType && data.item.accIdType === 'MOBILE')"
                  href="#"
                  >{{ data.item.email }}</a
                >
              </template>
              <template #cell(address)="data">
                {{ data.item.address + ', ' + data.item.district + ', ' + data.item.city }}
              </template>
              <template #cell(mcc)="data">
                {{ data.item.mcc | transfromMccName(dataConfigMcc) }}
              </template>
              <template #cell(service)="data">
                <span v-for="(itemm, indexx) in data.item.listActiveServices" :key="indexx">
                  {{ itemm.serviceType | serviceTypes }}
                </span>
              </template>
              <template #cell(source)="data">
                {{ data.item.referSource | mapTextStatus(sourceCreate) }} <br />
                {{ data.item.agentName }} <br />
                {{ data.item.agentMobile }}
              </template>
              <template #cell(sale)="data">
                <b>{{ data.item.activeSaleName }}</b
                ><br />
                <a href="javascript:void(0)">{{ data.item.activeSaleEmail }}</a
                ><br />
                <b v-if="data.item.isReassign">{{
                  data.item.isReassign | transformData(reassignOption)
                }}</b>
              </template>
              <template #cell(mposCreatedSaleName)="data">
                <b>{{ data.item.mposCreatedSaleName }}</b
                ><br />
                <a href="javascript:void(0)">{{ data.item.mposCreatedSaleEmail }}</a>
              </template>
              <template #cell(time)="data">
                <p class="text-nowrap">
                  <b>Tạo: </b> {{ data.item.createAt | formatHour1 }},
                  {{ data.item.createAt | formatDate1 }}
                </p>
                <p v-if="data.item.modifiedAt" class="text-nowrap">
                  <b>Cập nhật: </b> {{ data.item.modifiedAt | formatHour1 }},
                  {{ data.item.modifiedAt | formatDate1 }}
                </p>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.salesProcess ? data.item.salesProcess : '']">
                  {{ data.item.salesProcess | mapTextStatus(listState) }}
                </span>
              </template>
              <template #cell(statusKyc)="data">
                <span
                  class="badge"
                  :class="data.item.statusKyc ? data.item.statusKyc : 'NOT_PERFORMED'"
                  style="cursor: pointer"
                  @click="openHistoryKyc(data.item.customerId)"
                >
                  <template v-if="data.item.statusKyc">
                    {{ data.item.statusKyc | mapTextStatus(statusKycOptions) }}
                  </template>
                  <template v-else> Chưa thực hiện </template>
                </span>

                <p v-if="['ERROR', 'ACTIVE'].includes(data.item.statusKyc) && data.item.messageKyc">
                  <span class="text-muted">Lý do:</span>{{ data.item.messageKyc }}
                </p>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <div>
                    <button
                      class="dropdown-item"
                      v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_DETAIL')"
                      @click="detailList(data.item.customerId)"
                    >
                      <i class="bx bx-detail"></i><span>&nbsp;</span>Chi tiết
                    </button>
                    <button
                      class="dropdown-item"
                      v-if="
                        dataPermission &&
                        dataPermission.includes('CNPS_CSTM_MERCHANT_EKYC_VIEW') &&
                        data.item?.statusKyc
                      "
                      @click="openHistoryKyc(data.item.customerId)"
                    >
                      <i class="bx bx-history"></i><span>&nbsp;</span>Thông tin EKYC
                    </button>
                    <button
                      v-if="
                        callioConfig.active === true || dataUser.username === 'haopv@yopmail.com'
                      "
                      class="dropdown-item"
                      @click="setCurrentUserCall(data.item)"
                    >
                      <i class="bx bx-phone"></i><span>&nbsp;</span>Gọi điện
                    </button>
                    <button
                      class="dropdown-item"
                      @click="
                        openModalChangeSource(), (customerIdChangeSource = data.item.customerId)
                      "
                    >
                      <i class="bx bx-edit"></i>Đổi nguồn Merchant
                    </button>
                  </div>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
          class="fl-right mr-2"
        ></b-pagination>
      </div>
    </div>

    <b-modal id="modal-1" title="BootstrapVue">
      <template #modal-header>
        <h5 class="modal-title">Cập nhật trạng thái Merchant</h5>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click="$bvModal.hide('modal-1'), (stateSelected = '')"
        >
          ×
        </button>
      </template>

      <Select2
        :options="listState"
        placeholder="Chọn trạng thái Merchant"
        v-model="stateSelected"
      />

      <template #modal-footer>
        <button
          type="button"
          class="btn btn-secondary"
          @click="
            $bvModal.hide('modal-1'), (selected = []), (selectAll = false), (stateSelected = '')
          "
        >
          Huỷ
        </button>
        <button
          :disabled="stateSelected === ''"
          type="button"
          @click="updateStatusMC()"
          class="btn btn-primary"
        >
          Cập nhật
        </button>
      </template>
    </b-modal>

    <!--Modal thông báo-->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <developmentStaff
      title="Gán nhân viên chăm sóc MC"
      ref="developStaff"
      :showListStaff="showListStaff"
      @submit="assignSelectedStaff"
      @close="showListStaff = false"
    >
    </developmentStaff>
    <ModalExportNoti ref="uploadNotif" />
    <modalChangeSource
      v-if="canChangeSource"
      :systemConfig="systemConfig"
      :closeModal="closeModal"
      @updateInfo="updateInfoSource"
    />
    <HistoryKycModal :merchant-id="selectedMerchantId" @approve="fetchData" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import { MerchantService } from '@/services/merchant.service'
  import { CommonService } from '@/services/common.service'
  import ModalExportNoti from '@/components/ModalExportNoti.vue'
  import Config from '../../thirdParty/config'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment'
  import { AgentService } from '@/services/agent.service'
  import { SalesManagerService } from '@/services/sales-manager.service'
  import { MerchantPotentialService } from '@/services/merchantPotential.service'
  import developmentStaff from '@/pages/potential_customers/AssignModal/developmentStaff.vue'
  import modalChangeSource from './modalChangeSource.vue'
  import HistoryKycModal from './HistoryKycModal.vue'
  import merchantMx from '../../mixins/merchantMx'
  import { getLastNDays } from '@/utils/util'

  const fieldTable = [
    { key: 'selected', stickyColumn: true, isRowHeader: true },
    { key: 'merchant', label: 'Merchant' },
    { key: 'address', label: 'Địa chỉ' },
    { key: 'mcc', label: 'Ngành nghề' },
    { key: 'service', label: 'Dịch vụ ký HĐ' },
    { key: 'accquirerList', label: 'DS kích hoạt ONUS' },
    { key: 'source', label: 'Nguồn tạo' },
    { key: 'sale', label: 'Nhân viên chăm sóc' },
    { key: 'mposCreatedSaleName', label: 'Nhân viên phát triển HĐ MPOS' },
    { key: 'time', label: 'Thời gian' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'statusKyc', label: 'Trạng thái EKYC' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]

  export default {
    components: {
      DateRangePicker,
      developmentStaff,
      ModalExportNoti,
      modalChangeSource,
      HistoryKycModal,
    },
    data() {
      const { from, to } = getLastNDays(3, 'date')
      return {
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: true,
        selected: [],
        selectAll: false,
        userId: JSON.parse(localStorage.getItem('userData')).userId,
        callioConfig: JSON.parse(localStorage.getItem('callioConfig')) ?? {},
        listAfterSale: Config.listAfterSale,
        dataMerchant: [],
        dataProvince: [],
        optionsStaff: [],
        listUser: [],
        listCTV: [],
        listState: Config.listStatusMC,
        listStateSearch: [],
        sourceCreate: Config.sourceCreate,
        dataConfigRegion: [],
        search: {
          limit: 50,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        optionRule: [
          { text: 'Chưa xử lý', id: 0 },
          { text: 'Đã xử lý', id: 1 },
        ],
        dataConfigService: [],
        dataConfigMcc: [],
        localeData: Config.localeData,
        dateRange: {
          startDate: from,
          endDate: to,
        },
        stateSelected: '',
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        dataManager: [],
        checkSelectAll: false,
        showListStaff: false,
        selectedStaff: null,
        showLoading: false,
        dataSale: [],
        fieldTable,
        filterTable: fieldTable,
        canChangeSource: false,
        customerIdChangeSource: '',
        reassignOption: [
          { text: 'Cần gán lại NVCS', id: true },
          { text: 'Đã gán lại NVCS', id: false },
        ],
        enableReceivedOption: [
          { text: 'Tất cả', id: 0 },
          { text: 'Có', id: 1 },
          { text: 'Không', id: 2 },
        ],
        statusKycOptions: [
          { text: 'Thành công', id: 'ACTIVE' },
          { text: 'Thất bại', id: 'ERROR' },
        ],
        hasDefaultFilter: true,
        selectedMerchantId: '',
      }
    },

    mixins: [prepareQueryParamsMixin, merchantMx],

    filters: {
      transfromMccName(data, dataConfigMcc) {
        const dataReturn = dataConfigMcc.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
      transfromRegion(data, dataConfigRegion) {
        const dataReturn = dataConfigRegion.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
    },

    created() {
      this.transformDate()
      this.getDataSearch()
      this.fetchData()
      this.getManager()
      this.getListStaffBySuperior()
      this.getRegions()
      this.configSystem()
      this.getListCTV()
      this.getConfigSystem()
    },

    computed: {
      statusKycFilterOptions() {
        return [{ text: 'Tất cả', id: 0 }, ...this.statusKycOptions]
      },
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        dataSearch: 'search/getDataSearchOther',
        getRouter: 'search/getRouter',
      }),
      selectAllAction: {
        get: function () {
          return this.dataMerchant ? this.selected.length === this.dataMerchant.length : false
        },
        set: function (value) {
          var selected = []
          if (value) {
            this.dataMerchant.forEach(function (item) {
              selected.push(item.customerId)
            })
            this.checkSelectAll = true
          }
          this.selected = selected
        },
      },
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
        this.select()
      },
    },

    methods: {
      openHistoryKyc(customerId) {
        this.selectedMerchantId = customerId
        this.$bvModal.show('history-kyc-modal')
      },
      // nút lọc
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()

        this.$store.commit('search/SET_DATA_SEARCH_OTHER', {
          data: this.search,
          router: this.$router.currentRoute.path,
        })
      },
      // nút bỏ lọc
      async clearSearch() {
        this.search = {
          limit: 50,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }

        this.dataProvince = []
        this.hasDefaultFilter = false
        await this.fetchData()
      },
      removeTimeFilter() {
        this.dateRange = {
          startDate: null,
          endDate: null,
        }

        this.dataProvince = []
        this.hasDefaultFilter = false
        this.fetchData()
      },

      // xuất Excel
      async exportExcel() {
        try {
          this.showLoading = true
          this.search.userId = this.userId

          for (const key in this.search) {
            if (this.search[key] === '0') delete this.search[key]
          }
          // this.search.status = 'CURRENT_MERCHANT'
          if (this.search.regionId) {
            const data = this.dataConfigRegion.filter(e => {
              return this.search.regionId === e.id
            })
            this.search.regionName = data[0].text
          }
          const params = this.search
          delete params.page
          delete params.limit
          const body = {
            object: params,
            type: 'CNPS_CSTM_MERCHANT',
          }
          const data = await CommonService.receiveFile(body)
          if (data.success) {
            this.openModalLoadFile(data.data.id)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      openModalLoadFile(id) {
        this.$refs.uploadNotif.triggerNotification(id)
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: 0, text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {}
      },
      // Lấy danh sách nhân viên
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userId,
          })
          if (data.data.length > 0) {
            this.listUser = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.listUser.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // gọi điện
      setCurrentUserCall(data) {
        data.merchantType = 'MERCHANT'
        this.$store.commit('callio/SET_TMP_CURRENT_USER_CALL', data)
        this.$store.commit('callio/SET_MODAL', true)
        this.$store.commit('callio/SET_MODAL_MINI', false)
      },

      // lấy ngành hàng và dịch vụ
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.dataConfigService = data.data.services.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
              this.dataConfigService.unshift({ id: 0, text: 'Tất cả' })
              this.getListService()
              this.dataConfigMcc = data.data.businessFields.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
              this.dataConfigMcc.unshift({ id: 0, text: 'Tất cả' })
            }
          })
          .catch(error => console.log(error))
      },
      async getListService() {
        try {
          const response = await SalesManagerService.getGroupService({})
          if (response.code === 1000) {
            this.dataGroupService = response.data.groupService
            const data = this.dataGroupService.filter(e => e.service === 'SELL')
            if (data[0].detail.length > 0) {
              this.dataConfigService = data[0].detail.map(e => {
                return {
                  id: e.code,
                  text: this.serviceTypes(e.name),
                }
              })
            }
            // ListState
            this.listStateSearch = [{ id: 0, text: 'Tất cả' }, ...this.listState]
          }
        } catch (error) {
          console.log(error)
        }
      },
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
      // checkbox all
      select() {
        this.selected = []
        if (this.selectAll === true) {
          for (let i = 0; i <= this.dataMerchant.length; i++) {
            this.selected.push(this.dataMerchant[i].customerId)
          }
        }
      },
      // dữ liệu bảng
      async fetchData() {
        try {
          this.loading = true
          this.transformDate()
          this.search.userId = this.userId

          // this.search.status = ['CURRENT_MERCHANT']
          for (const key in this.search) {
            if (this.search[key] === '0') delete this.search[key]
          }
          const data = await MerchantService.getDataMerchant({
            ...this.search,
            ...(this.search.enableReceived && {
              enableReceived: this.search.enableReceived === '1',
            }),
          })
          if (data.success) {
            this.dataMerchant = data.data
            this.pagination.total = data.meta.pagination.total ? data.meta.pagination.total : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.selected = []
          this.loading = false
        }
      },

      transformDate() {
        this.search.startDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.endDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      async getListCTV() {
        try {
          const dataItem = await AgentService.listAgentByUser({
            userId: this.userId,
          })
          if (dataItem.success) {
            this.listCTV = dataItem.data.map(e => {
              return {
                id: e.agentId,
                text: e.name,
              }
            })
            this.listCTV.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      showModalUpdateStatus(merchantId) {
        this.$bvModal.show('modal-1')
        this.selected = []
        this.selectAll = false
        this.selected.push(merchantId)
      },
      async updateStatusMC() {
        try {
          const response = await MerchantService.updateStatusMC({
            lstCustomerIds: this.selected,
            salesProcess: this.stateSelected,
          })
          if (response.code === 1000) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Cập nhật trạng thái thành công'
            this.$bvModal.hide('modal-1')
            await this.fetchData()
            this.selectAll = false
            this.stateSelected = ''
          } else {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = response.message
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.selected = []
        }
      },

      getDataSearch() {
        if (JSON.stringify(this.dataSearch) === '{}') {
          this.search = {
            limit: 50,
            page: 1,
            userId: this.userId,
          }
        } else {
          if (this.$route.path === this.getRouter) {
            this.search = this.dataSearch
            this.dateRange.startDate = this.search.startDate
              ? new Date(this.search.startDate).toString()
              : null
            this.dateRange.endDate = this.search.endDate
              ? new Date(this.search.endDate).toString()
              : null
            if (this.search.regionId) this.queryProvince(this.search.regionId)
          }
          this.fetchData()
        }
      },

      async getManager() {
        try {
          const data = await StaffService.superiors()
          if (data.success) {
            this.dataManager = data.data.map(e => {
              return {
                id: e.id,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.dataManager.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },

      checkSelectedItem(customerId) {
        if (this.checkSelectAll && this.selected.length === 0) {
          const selected = []
          this.dataMerchant.forEach(item => {
            if (item.customerId !== customerId) selected.push(item.customerId)
          })
          this.selected = selected
        }
        if (this.selected.length !== 0) this.checkSelectAll = false
      },

      openPopupDeploymentStaff() {
        this.showListStaff = true
      },

      async assignSelectedStaff(data) {
        this.selectedStaff = data.userId.length > 0 ? data.userId[0] : ''
        this.dataSale = data.dataSale
        this.showListStaff = false
        this.showLoading = true
        await this.assignDeploymentStaff()
      },

      async assignDeploymentStaff() {
        try {
          const response = await MerchantPotentialService.assignDeploymentStaff({
            customerIds: this.selected,
            saleId: this.selectedStaff,
          })
          if (response.code === 1000) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = `Điều chuyển ${this.selected.length} merchant cho ${this.dataSale[0].name} thành công`
            await this.fetchData()
            setTimeout(() => {
              this.notiModal = false
            }, 1500)
          } else {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = response.message
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      detailList(id) {
        window.open(`/list-mc/${id}`)
      },
      openModalChangeSource() {
        this.canChangeSource = true
        this.$nextTick(s => this.$bvModal.show('change-source'))
      },
      closeModal() {
        this.$bvModal.hide('change-source')
        this.canChangeSource = false
        this.this.customerIdChangeSource = ''
      },
      async updateInfoSource(params) {
        this.showLoading = true
        try {
          const data = {
            customerId: this.customerIdChangeSource,
            ...params,
          }
          const response = await MerchantService.updateSource(data)
          if (response.code === 1000) {
            this.showSuccessMx('Đổi nguồn Merchant thành công')
            await this.fetchData()
            setTimeout(() => {}, 1500)
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
          this.closeModal()
        }
      },
    },
  }
</script>

<style scoped>
  .NEW {
    color: #fff;
    background-color: #707b7c;
  }

  .POTENTIAL {
    color: #fff;
    background-color: #f1c40f;
  }

  .HAS_CONTRACT {
    color: #fff;
    background-color: #28a745;
  }

  .APPROVAL {
    color: #fff;
    background-color: #1d8348;
  }

  .HANDOVER {
    color: #fff;
    background-color: #17a2b8;
  }

  .DONE,
  .ACTIVE {
    color: #fff;
    background-color: #007bff;
  }

  .REJECT {
    color: #fff;
    background-color: #dc3545;
  }

  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  .column-responsive {
    max-width: 10rem;
  }

  .column-responsive-2 {
    max-width: 13rem;
  }

  .ACTIVE {
    color: #fff;
    background-color: #28a745;
  }

  .ERROR {
    color: #fff;
    background-color: #dc3545;
  }

  .NOT_PERFORMED {
    color: #fff;
    background-color: #fd7e14;
  }
</style>
